import PageNotFound from "../../views/PageNotFound";

export default [
    {
        // will match everything
        path: '*',
        name: '404',
        component: PageNotFound,
        meta: {showNav: false, showOptionbar: false}
    }
]
